import React from "react";
import { API, graphqlOperation } from "aws-amplify";
import logger from "../logger";
import { updateProspect } from "../graphql/mutations";
import ConfirmSignUp from "../components/Auth/ConfirmSignUp";

const ConfirmarRegistro = props => {
  if (props.authState !== "confirmSignUp") {
    return null;
  }

  const confirmed = ({ email }) => {
    const vars = {
      input: {
        email,
        status: 1
      }
    };

    API.graphql(graphqlOperation(updateProspect, vars)).catch(err =>
      logger("ConfirmarRegistro.confirmed.error", err)
    );
  };

  return <ConfirmSignUp {...props} onConfirmed={confirmed} />;
};

export default ConfirmarRegistro;
